export interface IPayment {
    subTotal?: number;
    paymentId?: string;
    discountAmount?: number;
    isPaid?: boolean;
    shippingAmount?: number;
    grandTotal?: number;
    timestamp?: number;
    paymentMethod?: string;
}

export class Payment implements IPayment {
    subTotal?: number;
    paymentId?: string;
    discountAmount?: number;
    isPaid?: boolean;
    shippingAmount?: number;
    grandTotal?: number;
    timestamp?: number;
    paymentMethod?: string;

    constructor(data: IPayment) {
        this.subTotal = data.subTotal
        this.paymentId = data.paymentId
        this.discountAmount = data.discountAmount
        this.isPaid = data.isPaid
        this.shippingAmount = data.shippingAmount
        this.grandTotal = data.grandTotal
        this.timestamp = data.timestamp
        this.paymentMethod = data.paymentMethod
    }
}